import React from 'react';
import { Card } from './Card';
interface KPICardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  variant?: 'default' | 'positive' | 'neutral' | 'negative';
  change?: string;
  trend?: 'up' | 'down' | 'neutral';
  subtext?: string;
}
export function KPICard({
  title,
  value,
  icon,
  variant = 'default',
  change,
  trend,
  subtext
}: KPICardProps) {
  const variantStyles = {
    default: {
      bg: '',
      iconColor: 'text-lidl-blue opacity-80',
      titleColor: 'text-gray-500',
      valueColor: 'text-gray-900'
    },
    positive: {
      bg: 'bg-[#e8f5e4] border-[#639754]/20',
      iconColor: 'text-[#639754]',
      titleColor: 'text-[#4a7340]',
      valueColor: 'text-[#2d5a1e]'
    },
    neutral: {
      bg: 'bg-[#fffde6] border-[#FFF000]/30',
      iconColor: 'text-[#b39500]',
      titleColor: 'text-[#8a7300]',
      valueColor: 'text-[#6b5900]'
    },
    negative: {
      bg: 'bg-[#fde8e8] border-[#DF0000]/20',
      iconColor: 'text-[#DF0000]',
      titleColor: 'text-[#b32d25]',
      valueColor: 'text-[#8b1a13]'
    }
  };
  const styles = variantStyles[variant];
  return <Card className={`flex flex-col h-full justify-between transition-shadow duration-200 ${styles.bg}`} data-id="element-230">
      <div className="flex justify-between items-start mb-2" data-id="element-231">
        <span className={`text-sm font-medium ${styles.titleColor}`} data-id="element-232">
          {title}
        </span>
        {icon && <div className={styles.iconColor} data-id="element-233">{icon}</div>}
      </div>

      <div className="flex flex-col gap-1 mt-1" data-id="element-234">
        <h3 className={`text-2xl font-bold ${styles.valueColor}`} data-id="element-235">{value}</h3>

        {(change || subtext) && <div className="flex items-center gap-2 text-xs" data-id="element-236">
            {change && <span className={`font-medium ${trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-gray-600'}`} data-id="element-237">
                {change}
              </span>}
            {subtext && <span className="text-gray-400" data-id="element-238">{subtext}</span>}
          </div>}
      </div>
    </Card>;
}